import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]


export default /*#__PURE__*/_defineComponent({
  __name: 'EditButton',
  props: {
    title: null,
    data: null
  },
  setup(__props: any) {

// Accessible edit action for a DataTable `element` cell: a real <button> whose click bubbles to the
// wrapper's @click (openEdit), so keyboard and screen-reader users can trigger it. title = the label.


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "aria-label": __props.title,
    "data-testid": "daily-chest-edit-button",
    class: "px-4 py-1 rounded-full bg-yellow-500 hover:bg-yellow-700 text-white font-bold text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-yellow-500"
  }, _toDisplayString(__props.title), 9, _hoisted_1))
}
}

})